module.exports = __webpack_public_path__ + "static/blog-5592477c1840df34cf0f96bdd2e336aa.jpg";